$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  $('.header .socialNetworks').clone().appendTo('.mobile-menu-container .mobile-menu-subheader');
  createBurgerIcon();
});

// Helpers
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<div></div>');
  });
}
